import React from "react";
import PhotoHistoryIcon from "../../shared/icons/PhotoHistoryIcon";
import AnalyticsIcon from "../../shared/icons/AnalyticsIcon";
import SupportIconMenu from "../../shared/icons/SupportIconMenu";
import UsersIcon from "../../shared/icons/UsersIcon";
import LupeIcon from "../../shared/icons/LupeIcon";
import LoaderProgress from "../loader-progress/LoaderProgress";
import OrdersIcon from "../../shared/icons/OrdersIcon";
import DraftsIcon from "../../shared/icons/DraftsIcon";
import WalletIcon from "../../shared/icons/WalletIcon";
import SettingsIcon from "../../shared/icons/SettingsIcon";
import GarageIcon from "../../shared/icons/GarageIcon";
import PartnerIcon from "../../shared/icons/PartnerIcon";
import AirplaneIcon from "../../shared/icons/transport-type/AviaOrdersIcon";
import HandshakeIcon from "../../shared/icons/HandshakeIcon";
import { canAccessNewAnalytics } from "../../../utils/canAccessNewAnalytics";
import RailwayIcon from "../../shared/icons/RailwayIcon";
import { RAILWAY_ORDERS_PATH, RAILWAY_EXPEDITOR_ORDERS_PATH } from "../../../pages/orders/utils/railwayOrder";


const commonNavigation = [
  {
    title: "Аналитика",
    icon: <AnalyticsIcon />,
    link: "/analytics",
  },
  {
    title: "Поддержка",
    icon: <SupportIconMenu />,
    link: "/support",
  },
];

const clientTopMenu = [
  {
    title: "Заказы",
    icon: <OrdersIcon />,
    link: "/main",
    children: [],
  },
  {
    title: "Черновики",
    icon: <DraftsIcon />,
    link: "/orders/draft",
  },
  {
    title: "Аналитика",
    icon: <AnalyticsIcon  />,
    link: "/analytics",
  },
  {
    title: "Сотрудники",
    icon: <UsersIcon  />,
    link: "/workers",
  },
  {
    title: "История заказов",
    icon: <PhotoHistoryIcon  />,
    link: "/orders/history",
  },
];

export const getMenuExpeditor = (t, user) => [
  {
    title: t('sidebarMenu.onboarding'),
    icon: <LoaderProgress  />,
    link: "/onboarding-expeditor",
    content: "border",
    display: "none",
    tooltip: t('tooltips.onboarding'),
  },
  {
    title: t('sidebarMenu.airOrders'),
    icon: <AirplaneIcon  />,
    link: "/orders-aviation/available",
  },
  // {
  //   title: t('sidebarMenu.orderSearch'),
  //   icon: <LupeIcon  />,
  //   link: "/orders/search",
  // },
  {
    title: t('sidebarMenu.orders'),
    icon: <OrdersIcon  />,
    link: "/orders/available",
  },
  {
    title: t("sidebarMenu.railwayOrders"),
    icon: <RailwayIcon width="24" height="24" color="#212121" strokeWidth={1.5} />,
    link: RAILWAY_EXPEDITOR_ORDERS_PATH,
    isStroke: true,
    tooltip: t("sidebarMenu.railwayOrders"),
  },
  {
    title: t('sidebarMenu.drafts'),
    icon: <DraftsIcon  />,
    link: "/orders/draft",
  },
  {
    title: t('sidebarMenu.fleet'),
    icon: <GarageIcon  />,
    link: "/cars",
    tooltip: t('tooltips.fleet'),
  },
  {
    title: t('sidebarMenu.drivers'),
    icon: <UsersIcon />,
    link: "/drivers",
    tooltip: t('tooltips.drivers'),
  },
  {
    title: t('sidebarMenu.partners'),
    icon: <HandshakeIcon  />,
    link: "/partners",
    isStroke: true
  },
  // {
  //   title: t('sidebarMenu.market'),
  //   icon: <PartnerIcon  />,
  //   link: "/marketplace",
  // },
  {
    title: t('sidebarMenu.analytics'),
    icon: <AnalyticsIcon  />,
    link: "/analytics",
  },
  // {
  //   title: t("analyticsNew.menu", "Новая аналитика"),
  //   icon: <AnalyticsIcon />,
  //   link: "/analytics-new",
  // },
  {
    title: t('sidebarMenu.employees'),
    icon: <UsersIcon  />,
    link: "/workers",
  },
  {
    title: t('sidebarMenu.settings'),
    icon: <SettingsIcon  />,
    link: "/profile",
  },
].filter(item => {
  if (item.link === "/orders/search") {
    return user?.permissions?.includes('order_view');
  }
  return true;
});


export const getMenuClient = (t, user) => [
  {
    title: t('sidebarMenu.onboarding'),
    icon: <LoaderProgress />,
    link: "/onboarding",
    content: "border",
    display: "none",
    tooltip: t('tooltips.onboarding'),
  },
  {
    title: t('sidebarMenu.airOrders'),
    icon: <AirplaneIcon  />,
    link: "/aviation/list",
    tooltip: t('tooltips.airFreightManagement'),
  },
  {
    title: t('sidebarMenu.orders'),
    icon: <OrdersIcon  />,
    link: "/main",
    tooltip: t('tooltips.roadTransportOrders'),
  },
  {
    title: t("sidebarMenu.railwayOrders"),
    icon: <RailwayIcon width="24" height="24" color="#212121" strokeWidth={1.5} />,
    link: RAILWAY_ORDERS_PATH,
    isStroke: true,
    tooltip: t("sidebarMenu.railwayOrders"),
  },
  {
    title: t('sidebarMenu.drafts'),
    icon: <DraftsIcon  />,
    link: "/orders/draft",
    tooltip: t('tooltips.draftOrders'),
  },
  {
    title: t('sidebarMenu.partners'),
    icon: <HandshakeIcon  />,
    link: "/partners",
    isStroke: true,
    tooltip: t('tooltips.trustedCarriers'),
  },
  // {
  //   title: t('sidebarMenu.market'),
  //   icon: <PartnerIcon  />,
  //   link: "/marketplace",
  //   tooltip: t('tooltips.marketplaceSearch'),
  // },
  {
    title: t('sidebarMenu.analytics'),
    icon: <AnalyticsIcon  />,
    link: "/analytics",
    tooltip: t('tooltips.reportsAndKpi'),
  },
  ...(canAccessNewAnalytics(user?.companyId)
    ? [
        {
          title: t("analyticsNew.menu", "Новая аналитика"),
          icon: <AnalyticsIcon />,
          link: "/analytics-new",
        },
      ]
    : []),
  {
    title: t('sidebarMenu.employees'),
    icon: <UsersIcon  />,
    link: "/workers",
    tooltip: t('tooltips.userManagement'),
  },
  // {
  //   title: t('sidebarMenu.balance'),
  //   icon: <WalletIcon  />,
  //   link: "/balance/lists",
  // },
  {
    title: t('sidebarMenu.settings'),
    icon: <SettingsIcon  />,
    link: "/profile",
  },
];

export { commonNavigation, clientTopMenu };
